import { __rest, __assign } from '../../../../../_virtual/_tslib.js';
import React from 'react';
import { theme } from '@citygross/design-tokens';
import { RadioWrapper, RadioInput, CustomRadio } from './Radio.styles.js';

function Radio(_a) {
  var onChange = _a.onChange,
      _b = _a.customColor,
      customColor = _b === void 0 ? 'alertGreen' : _b,
      inputProps = __rest(_a, ["onChange", "customColor"]);

  return React.createElement(RadioWrapper, {
    whileHover: {
      scale: 1.1
    },
    whileTap: {
      scale: 0.9
    }
  }, React.createElement(RadioInput, __assign({
    type: "radio",
    onChange: onChange,
    customColor: theme && theme.palette ? theme === null || theme === void 0 ? void 0 : theme.palette[customColor] : 'white'
  }, inputProps)), React.createElement(CustomRadio, {
    customColor: theme && theme.palette ? theme === null || theme === void 0 ? void 0 : theme.palette[customColor] : 'white'
  }));
}

export { Radio };